import { pages } from '../constants';
import withContentful from '../withContenfull';
import Support from './Support';

export default withContentful(pages.support)(Support);
